// extracted by extract-css-chunks-webpack-plugin
module.exports = {"title":"title_oeTtm","container":"container_nhL4b","table":"table_p7gSz","table__inner":"table__inner_ZEQrl","ui_mask":"ui_mask_wztSA"};